import React, { ReactNode } from 'react';
import { IMAGE_URL } from '@ordermentum/ui-constants';
import EmptyState from '@ordermentum/ui-shared/patterns/EmptyState/EmptyState';
import { Header } from '../DefaultLogin';

const TextWrapper = ({ children }: { children: ReactNode }) => (
  <p className="font-body text-base text-center font-normal text-subtle">
    {children}
  </p>
);

export const SignupSuccess = () => (
  <div className="flex flex-col h-screen">
    <div className="flex bg-regular w-full py-4 md:py-8 justify-center items-center border-b border-solid border-background-subtle">
      <Header />
    </div>
    <div
      className="w-full h-full bg-repeat py-14 grid justify-center items-center"
      style={{
        backgroundImage: `url("${IMAGE_URL}/tiled-food-bg-1.png")`,
      }}
    >
      <div className="bg-regular w-mobile-central-single-content px-5 py-10 mx-4 sm:w-central-single-content sm:p-10 rounded-xl flex flex-col gap-8">
        <EmptyState
          imageType="animation"
          animationName="email"
          animationSize="S"
          heading="Verify your email"
          altText="A paper airplane flying against the wind"
        >
          <TextWrapper>
            You&apos;re almost ready to go. We&apos;ve sent you an email with a
            link to verify your account.
          </TextWrapper>
          <div>
            <TextWrapper>
              If you haven&apos;t received the email within 10 minutes, please
              check your spam folder.
            </TextWrapper>
            <TextWrapper>
              Otherwise,{' '}
              <a
                data-testid="contact-support-link"
                className="text-primary-brand hover:text-primary-interactive underline font-normal underline-offset-4 decoration-1"
                href="mailto:support@ordermentum.com"
              >
                contact us
              </a>{' '}
              for support.
            </TextWrapper>
          </div>
        </EmptyState>
      </div>
    </div>
  </div>
);
